"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _NuggetBack = _interopRequireDefault(require("./NuggetBack.scss"));

var _NestedFlipTiles = _interopRequireDefault(require("./NestedFlipTiles.scss"));

var _DrupalLecture = _interopRequireDefault(require("./DrupalLecture"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _ScreenHelper = _interopRequireDefault(require("../../../helpers/ScreenHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _StringHelper = _interopRequireDefault(require("../../../helpers/StringHelper"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _AppUtils = require("../../../utils/AppUtils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var BUTTON_HEIGHT = 30;
var BUTTON_PADDING = 10; // see CSS

var DrupalNuggetBack = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(DrupalNuggetBack, _React$Component);

  var _super = _createSuper(DrupalNuggetBack);

  function DrupalNuggetBack(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, DrupalNuggetBack);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onLectureFrameScrolledProgrammatically", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
        var lectureFrame, currentScrollTop, extraSpaceBottom;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lectureFrame = document.getElementById(_this.lectureFrameId);
                currentScrollTop = lectureFrame.scrollTop;
                extraSpaceBottom = event.detail.extraSpaceBottom || 0; // try three times as there might be a blank screen

                lectureFrame.scrollTop = currentScrollTop + extraSpaceBottom + 1;
                _context.next = 6;
                return (0, _TimeoutHelper.timeout)(50);

              case 6:
                lectureFrame.scrollTop = currentScrollTop + extraSpaceBottom - 1;
                _context.next = 9;
                return (0, _TimeoutHelper.timeout)(50);

              case 9:
                lectureFrame.scrollTop = currentScrollTop + extraSpaceBottom;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onWidescreenChanged", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                hidden: true
              });

              _context2.next = 3;
              return (0, _TimeoutHelper.timeout)();

            case 3:
              _this.setState({
                hidden: false
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goBack", function () {
      var path = _NavigationManagerCordova["default"].getCurrentPath();

      var pathParts = path.split(_KesiConstants.KESI_PATH_DELIMITER);
      pathParts.pop();
      var urlToGoTo = pathParts.join(_KesiConstants.KESI_PATH_DELIMITER);

      _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(urlToGoTo));
    });
    _this.state = {
      hidden: false
    };
    _this.lectureFrameId = _StringHelper["default"].createShortId();
    _this.isInternetExplorer = _DeviceInfoHelper["default"].isInternetExplorer();
    return _this;
  }

  (0, _createClass2["default"])(DrupalNuggetBack, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().addOnWidescreenChangedListener(this.onWidescreenChanged);
      }

      document.addEventListener('lectureFrameScrolledProgrammatically', this.onLectureFrameScrolledProgrammatically);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().removeOnWideScreenChangedListener(this.onWidescreenChanged);
      }

      document.removeEventListener('lectureFrameScrolledProgrammatically', this.onLectureFrameScrolledProgrammatically);
    }
  }, {
    key: "getButtonStyle",
    value: function getButtonStyle() {
      return {
        left: _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES,
        width: this.props.tileSize * this.props.zoomValue,
        height: BUTTON_HEIGHT,
        lineHeight: "".concat(BUTTON_HEIGHT - BUTTON_PADDING, "px")
      };
    }
  }, {
    key: "getId",
    value: function getId() {
      return "tile_back_".concat(this.props.contentId);
    }
  }, {
    key: "getLectureStyle",
    value: function getLectureStyle() {
      if (_config["default"].showLectureSidebar) {
        return {
          width: "calc(100vw - ".concat((this.props.tileSize + 2 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES) * this.props.zoomValue, "px)") // height: '100vh'

        };
      }

      return {
        width: '100vw'
      };
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(event) {
      var shouldPreventDefault = true;
      var target = event.target;

      while (true) {
        if (target.getAttribute('id') === this.getId()) {
          break;
        }

        if (target.className && typeof target.className === 'string' && target.className.indexOf(_NuggetBack["default"].lectureFrame) >= 0) {
          shouldPreventDefault = false;
          break;
        }

        target = target.parentNode;
      }

      if (shouldPreventDefault) {
        event.preventDefault();
      }
    }
  }, {
    key: "renderFavoriteButton",
    value: function renderFavoriteButton() {
      var style = this.getButtonStyle();
      style.top = this.props.tileSize * this.props.zoomValue + _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES * 3;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_NuggetBack["default"].favoriteButton, " ").concat(this.props.colorClasses.backgroundClass),
        style: style
      }, "Als Favorit speichern");
    }
  }, {
    key: "renderGoUpButton",
    value: function renderGoUpButton() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_NestedFlipTiles["default"].tilesButtonsClose, " ").concat(_NestedFlipTiles["default"].posAbs, " ").concat(this.props.showGoUpButton ? '' : _NestedFlipTiles["default"].hiddenByOpacity)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        onClick: this.props.goUpFunc,
        className: _NestedFlipTiles["default"].closeButton
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "times"
      })));
    }
  }, {
    key: "renderReadingStateButton",
    value: function renderReadingStateButton() {
      var style = this.getButtonStyle();
      style.top = this.props.tileSize * this.props.zoomValue + _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES * 6 + BUTTON_HEIGHT;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_NuggetBack["default"].readingStateButton, " ").concat(this.props.colorClasses.backgroundClass),
        style: style
      }, "Als gelesen markieren");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // this.props.setCount(-1);
      if (this.state.hidden) {
        return null;
      }

      var content = _KESI2Helper["default"].getContentById(this.props.contentId);

      var spocHasRubrics = content && content.type === 'spoc' && content.rubrics && content.rubrics.length > 0;
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: this.getId(),
        className: this.isInternetExplorer && !spocHasRubrics && !this.props.doNotRenderFlipping ? _NuggetBack["default"].nuggetBackIE : _NuggetBack["default"].nuggetBack,
        onTouchMove: this.onTouchMove.bind(this)
      }, _config["default"].showLectureSidebar ? this.props.tile : null, _config["default"].showLectureSidebar ? this.renderFavoriteButton() : null, _config["default"].showLectureSidebar ? this.renderReadingStateButton() : null, _config["default"].showLectureSidebar ? this.renderGoUpButton() : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetBack["default"].lectureFrame,
        style: this.getLectureStyle(),
        id: this.lectureFrameId
      }, /*#__PURE__*/_react["default"].createElement(_DrupalLecture["default"], {
        key: "lecture_".concat(this.props.contentId),
        params: {
          contentId: this.props.contentId
        },
        doNotSetHeight: this.props.doNotSetHeight,
        colorClasses: this.props.colorClasses,
        contentPathArray: this.props.contentPathArray,
        setShowFavButton: this.props.setShowFavButton,
        goUpFunc: this.props.goUpFunc,
        setBackButtonFunc: this.props.setBackButtonFunc,
        closeTile: function closeTile() {
          _this2.goBack();
        },
        forcedUIColor: this.props.forcedUIColor
      })));
    }
  }]);
  return DrupalNuggetBack;
}(_react["default"].Component);

DrupalNuggetBack.propTypes = {
  colorClasses: _propTypes["default"].shape({
    backgroundClass: _propTypes["default"].string.isRequired,
    glowClass: _propTypes["default"].string.isRequired
  }),
  contentId: _propTypes["default"].string.isRequired,
  setCount: _propTypes["default"].func.isRequired,
  tile: _propTypes["default"].node.isRequired,
  tileSize: _propTypes["default"].number.isRequired,
  doNotSetHeight: _propTypes["default"].bool.isRequired,
  zoomValue: _propTypes["default"].number.isRequired,
  goUpFunc: _propTypes["default"].func.isRequired,
  showGoUpButton: _propTypes["default"].bool.isRequired,
  contentPathArray: _propTypes["default"].array,
  setShowFavButton: _propTypes["default"].func,
  setBackButtonFunc: _propTypes["default"].func,
  doNotRenderFlipping: _propTypes["default"].bool,
  forcedUIColor: _propTypes["default"].string
};
var _default = DrupalNuggetBack;
exports["default"] = _default;